import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { Permission, SessionDto } from '@cw/shared';
import { api } from './api';
import { qk } from './query';

export function useSession() {
  return useQuery({ queryKey: qk.session, queryFn: () => api.get<SessionDto>('/auth/me'), retry: false });
}

/** Sessão garantida: só usar dentro do AppShell (que já validou o login). */
export function useMe(): SessionDto {
  const { data } = useSession();
  if (!data) throw new Error('useMe usado fora de uma rota autenticada');
  return data;
}

export function useCan(permission: Permission): boolean {
  return useMe().permissions.includes(permission);
}

export function useRefreshSession() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: qk.session });
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout');
}
